// extracted by mini-css-extract-plugin
export default {"wrapper":"hs-z","response":"is-z","error":"js-z","disabled":"ks-z","buttons":"ls-z","feedbackQuestionSection":"ms-z","yesNoWrapper":"ns-z"};